import { enqueueSnackbar } from 'actions';

import {
	GetUsersRequest,
	GetUsersStatsRequest,
	GetRolesRequest,
	GetOperatorsRequest,
	GetOperatorProjectsRequest,
	CreateUserRequest,
	GetUserRequest,
	EditUserRequest,
	ResendConfirmationEmailRequest,
	DeactivateUserRequest,
} from '../requests/UsersRequests.js';

export const GET_USERS = 'GET_USERS';
export const GET_USERS_STATS = 'GET_USERS_STATS';
export const TOGGLE_ADD_EDIT_USER_DIALOG = 'TOGGLE_ADD_EDIT_USER_DIALOG';
export const GET_ROLES = 'GET_ROLES';
export const GET_OPERATORS = 'GET_OPERATORS';
export const GET_OPERATOR_PROJECTS = 'GET_OPERATOR_PROJECTS';
export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_USER = 'GET_USER';

const onGetUsers = (value) => ({
	type: GET_USERS,
	users: value
});

const onGetUsersStats = (value) => ({
	type: GET_USERS_STATS,
	usersStats: value
});

const onToggleAddEditUserDialog = (openAddEditUserDialog, openAddEditUserDialogId) => ({
	type: TOGGLE_ADD_EDIT_USER_DIALOG,
	openAddEditUserDialog,
	openAddEditUserDialogId
});

const onGetRoles = (value) => ({
	type: GET_ROLES,
	roles: value
});

const onGetOperators = (value) => ({
	type: GET_OPERATORS,
	operators: value
});

const onGetOperatorProjects = (value) => ({
	type: GET_OPERATOR_PROJECTS,
	operatorProjects: value
});

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onGetUser = (value) => ({
	type: GET_USER,
	user: value
});

export const GetUsers = (role) => async (dispatch) => {
	await GetUsersRequest(role).then(response => {
		dispatch(onGetUsers(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetUsersStats = () => async (dispatch) => {
	await GetUsersStatsRequest().then(response => {
		dispatch(onGetUsersStats(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleAddEditUserDialog = (openAddEditUserDialog, openAddEditUserDialogId) => (dispatch) => {
	dispatch(onToggleAddEditUserDialog(openAddEditUserDialog, openAddEditUserDialogId));
};

export const GetRoles = (role) => async (dispatch) => {
	await GetRolesRequest(role).then(response => {
		dispatch(onGetRoles(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetOperators = () => async (dispatch) => {
	await GetOperatorsRequest().then(response => {
		dispatch(onGetOperators(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetOperatorProjects = (operatorIds) => async (dispatch) => {
	await GetOperatorProjectsRequest(operatorIds).then(response => {
		dispatch(onGetOperatorProjects(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const CreateUser = (userData, role) => async (dispatch) => {
	await CreateUserRequest(userData).then(response => {
		dispatch(enqueueSnackbar({ message: 'New user created!', options: { key: new Date().getTime() + Math.random(), variant: 'success' } }));
		dispatch(GetUsers(role));
		dispatch(GetUsersStats());
		dispatch(ToggleAddEditUserDialog(false));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const EditUser = (userData, role) => async (dispatch) => {
	await EditUserRequest(userData).then(response => {
		dispatch(GetUsers(role));
		dispatch(GetUsersStats());
		dispatch(ToggleAddEditUserDialog(false));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetUser = (userId) => async (dispatch) => {
	await GetUserRequest(userId).then(response => {
		dispatch(onGetUser(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ResendConfirmationEmail = (userId) => async (dispatch) => {
	await ResendConfirmationEmailRequest(userId).then(response => {
		dispatch(enqueueSnackbar({ message: 'Confirmation email sent!', options: { key: new Date().getTime() + Math.random(), variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const DeactivateUser = (userId, role) => async (dispatch) => {
	await DeactivateUserRequest(userId).then(response => {
		dispatch(GetUsers(role));
		dispatch(GetUsersStats());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
